import fetch from '@/utils/fetch';
const GatewayAccount = '/account'
const GatewayProduct = "/product";
const GatewayOrder = "/order";
const GatewayOauth2 = "/oauth2";
const ApiPath = '/api'
const PathPerAccount = ApiPath+GatewayAccount
const PathPerProduct = ApiPath+GatewayProduct
const PathPerOrder = ApiPath+GatewayOrder
const PathPerOauth2 = ApiPath+GatewayOauth2
//   产品服务
/**
 * 店铺首页、首页管理
 */
export function smallShopList(query) {
    return fetch({
      url: PathPerProduct + "/smallPro/list",
      method: "get",
      params: query,
      noLoading: true,
    });
  }

/**
 * 新增产品
 */
export function smallShopCreate(query) {
    return fetch({
      url: PathPerProduct + "/smallPro/create",
      method: "get",
      params: query,
      noLoading: true,
    });
  }
  
/**
 *分片上传 参考shardUploadInfo
 */
 export function smallShopShardUpload(files) {
    return fetch({
      url: PathPerProduct + "/smallPro/shardUpload",
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: files,
    });
  }
  /**
   *分片合并 参考mergeUploadInfo
   */
  export function smallShopMergeUpload(query) {
      return fetch({
        url: PathPerProduct + "/smallPro/merge",
        method: "post",
        params: query,
      });
  }
  /**
 *产品的详情图片上传
 */
 export function uploadPicDetailInfo(files) {
    return fetch({
      url: PathPerProduct + "/pic/uploadPic",
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: files,
      noLoading: true,
    });
  }
/**
 * 保存/编辑产品 参考saveInfo
 */
export function smallShopSaveInfo(files) {
    return fetch({
      url: PathPerProduct + "/smallPro/save",
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: files,  
      noLoading: true,
    });
  }

  /**
 * 上架/下架
 */
export function smallShopBatchShelf(query) {
    return fetch({
      url: PathPerProduct + "/smallPro/batchShelf",
      method: "post",
      data: query,
      noLoading: true,
    });
  }

  /**
 * 客户进入店铺
 */
export function smallShopEnterShop(query) {
    return fetch({
      url: PathPerProduct + "/smallPro/customer/list",
      method: "get",
      params: query,
    });
  }
  /**
     * 入驻小店
     */
  export function smallShopRegisterShop(query) {
    return fetch({
      url: PathPerAccount + "/company/registerShop",
      method: "post",
      params: query,
    });
  }
  /**
   * 获取验证码 
   */
  export function smallShopGetVerifyCode(query) {
    return fetch({
      url: PathPerAccount + "/alibaba/getCode",
      method: "post",
      params: query,
    });
  }
  // 认证服务*************************************************************
  /**
   * 微信注册 
   */
  export function smallShopBindVx(query) {
    return fetch({
      url: PathPerOauth2 + "/login/openIdLogin",
      method: "post",
      params: query,
    });
  }
//   产品服务-云仓************************************************************************
  /**
   * 云仓（产品列表） 
   */
  export function smallShopWarehouseList(query) {
    return fetch({
      url: PathPerProduct + "/product/findPage",
      method: "get",
      params: query,
      noLoading: true,
        });
  }
    /**
     * 新增产品（只生成id) 
     */
    export function smallShopWarehouseCreate(query) {
        return fetch({
        url: PathPerProduct + "/product/id",
        method: "get",
        params: query,
        noLoading: true,
      });
  }
  /**
   * 保存/编辑  /product/save
   */
  export function smallShopWarehouseSave(query) {
    return fetch({
      url: PathPerProduct + "/product/save",
      method: "post",
      params: query,
      noLoading: true,
    });
  }
  /**
   * 下拉选择分类列表 
   */
  export function smallShopWarehouseCategoryList(query) {
    return fetch({
      url: PathPerProduct + "/category/select",
      method: "get",
      params: query,
      noLoading: true,
    });
  }
  /**
   * 视频分片上传 
   */
  export function smallShopWarehouseShardUpload(files) {
    return fetch({
      url: PathPerProduct + "/product/shardUpload",
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: files,
      noLoading: true,
    });
  }
  /**
     * 视频分片合并 
     */
    export function smallShopWarehouseMergeUpload(query) {
        return fetch({
          url: PathPerProduct + "/product/merge",
          method: "post",
          params: query,
          noLoading: true,
        });
  }
  /**
   * 产品图片上传 
   */
  export function smallShopWarehouseUploadPic(files) {
    return fetch({
      url: PathPerProduct + "/pic/uploadPic",
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: files,
      noLoading: true,
    });
  }
  /**
   * 加入云仓 
   */
  export function smallShopWarehouseJoin(query) {
    return fetch({
      url: PathPerProduct + "/smallPro/addXpz",
      method: "post",
      params: query,
      noLoading: true,
    });
  }
// ********************************************************************************
//   账号服务
/**
 *编辑店铺名 参考接口editCompanyInfo
 */
 export function editShopName(query) {
    return fetch({
      url: PathPerAccount + "/company/editShopName",
      method: "post",
      params: query,
    });
  }
/**
 *显示/隐藏价格
 */
 export function showPrice(query) {
    return fetch({
      url: PathPerAccount + "/company/showPrice",
      method: "post",
      params: query,
    });
  }
    /**
 * 查询店铺信息 参考reCompanyInfo
 */
export function shopInfo(query) {
    return fetch({
      url: PathPerAccount + "/company/shopInfo",
      method: "get",
      params: query,
      noLoading: true,
    });
  }

/**
 * 生成产品二维码
 */
export function generateProductQrCode(query) {
    return fetch({
      url: PathPerProduct + "/smallPro/qrCode",
      method: "get",
      params: query,
      noLoading: true,
    });
  }

/**
 * 获取产品详情 扫描二维码查看时和编辑产品的时候要用
 */
export function getSmallShopProductDetail(query) {
    return fetch({
      url: PathPerProduct + "/smallPro/findById",
      method: "get",
      params: query,
      noLoading: true,
    });
  }
  /**
   * 上传背景图片 
   */
  export function smallShopUploadBackgroundPic(files) {
    return fetch({
      url: PathPerAccount + "/company/backgroundUpload",
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: files,
      noLoading: true,
    });
  }
  /**
   * 上传头像 
   */
  export function smallShopUploadAvatarPic(files) {
    return fetch({
      url: PathPerAccount + "/company/avatarUpload",
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: files,
      noLoading: true,
    });
  }














//   订单服务
/**
 * 加购
 */
export function addCart(query) {
    return fetch({
      url: PathPerOrder + "/shopCart/addCart",
      method: "post",
      params: query,
      noLoading: true,
    });
  }
  /**
   * 购物车列表 
   */
  export function findCartList(query) {
    return fetch({
      url: PathPerOrder + "/shopCart/list",
      method: "get",
      params: query,
      noLoading: true,
    });
  }
  /**
   * 删除购物车 
   */
  export function deleteCart(query) {
    return fetch({
      url: PathPerOrder + "/shopCart/delete",
      method: "post",
      params: query,
      noLoading: true,
    });
  }
  /**
   * 清空购物车 
   */
  export function clearCart(query) {
    return fetch({
      url: PathPerOrder + "/shopCart/deleteBatch",
      method: "post",
      params: query,
      noLoading: true,
    });
  }
  /**
   * 意向单保存 
   */
  export function saveIntentOrder(files) {
    return fetch({
      url: PathPerOrder + "/shopOrder/save",
      method: "post",
      data: files,
      noLoading: true,
    });
  }
  /**
   * 意向单列表(小店)
   */
  export function intentOrderList(query) {
    return fetch({
      url: PathPerOrder + "/shopOrder/list",
      method: "get",
      params: query,
      noLoading: true,
    });
  }
  /**
   * 意向单列表(客户) 
   */
  export function findIntentOrderList(query) {
    return fetch({
      url: PathPerOrder + "/shopOrder/customer/list",
      method: "get",
      params: query,
      noLoading: true,
    });
  }
  /**
   * 意向单详情 
   */
  export function findIntentOrderById(query) {
    return fetch({
      url: PathPerOrder + "/shopOrder/findById",
      method: "get",
      params: query,
      noLoading: true,
    });
  }
  /**
   * 意向单删除 
   */
  export function deleteIntentOrderById(query) {
    return fetch({
      url: PathPerOrder + "/shopOrder/delete",
      method: "post",
      params: query,
      noLoading: true,
    });
  }
  /**
   * 生成报价单 
   */
  export function saveQuote(files) {
    return fetch({
      url: PathPerOrder + "/shopQuote/save",
      method: "post",
      data: files,
      noLoading: true,
    });
  }
  /**
  报价单列表 
   */
  export function listQuote(query) {
    return fetch({
      url: PathPerOrder + "/shopQuote/list",
      method: "get",
      params: query,
      noLoading: true,
    });
  }
  /**
   * 报价单详情 
   */
  export function findQuoteById(query) {
    return fetch({
      url: PathPerOrder + "/shopQuote/findById",
      method: "get",
      params: query,
      noLoading: true,
    });
  }
  /**
 * 获取报价单excel地址
 */
export function smallShopQuoteExcelUrl(query) {
  return fetch({
    url: PathPerOrder + "/shopQuote/excelUrl",
    method: "get",
    params: query,
  });
}